import React from 'react';
import { IoChatbubbleEllipsesOutline, IoImagesOutline } from 'react-icons/io5';

export type PageType = 'chat' | 'gallery';

interface BottomNavProps {
  currentPage: PageType;
  onPageChange: (page: PageType) => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ currentPage, onPageChange }) => {
  const itemClass = (page: PageType) =>
    `flex flex-col items-center justify-center p-3 rounded-xl transition-all ${
      currentPage === page
        ? 'bg-gradient-to-r from-[#7C3AED] to-[#3B82F6] text-white shadow-lg shadow-[#3B82F6]/25'
        : 'text-[#A1A1AA] hover:text-white hover:bg-[#7C3AED]/12'
    }`;

  return (
    <div className="bg-[#09090B]/95 border-t border-[#7C3AED]/20 flex justify-around items-center p-2 shadow-[0_-10px_28px_rgba(124,58,237,0.10)] backdrop-blur">
      <button
        onClick={() => onPageChange('chat')}
        className={itemClass('chat')}
      >
        <IoChatbubbleEllipsesOutline size={24} />
        <span className="text-xs mt-1">Chat</span>
      </button>
      <button
        onClick={() => onPageChange('gallery')}
        className={itemClass('gallery')}
      >
        <IoImagesOutline size={24} />
        <span className="text-xs mt-1">Gallery</span>
      </button>
    </div>
  );
};

export default BottomNav;
